import { render, staticRenderFns } from "./Registerlayout.vue?vue&type=template&id=0a938022&"
import script from "./Registerlayout.vue?vue&type=script&lang=js&"
export * from "./Registerlayout.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports